// extracted by mini-css-extract-plugin
module.exports = {"circleLoader":"Loader_circleLoader__6dvC7","rotate-circle":"Loader_rotate-circle__NTHTC","animate-dash":"Loader_animate-dash__sGAAH"};